import { useState } from "react";

const CustomTextField = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  name,
  required = false,
  error = "",
  disabled = false,
  size = "medium",
  className = "",
  multiline = false,
  rows = 3,
  minRows,
  numericOnly = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const sizeStyles = {
    small: { fontSize: "0.8rem", padding: "6px 10px" },
    medium: { fontSize: "1rem", padding: "8px 12px" },
    large: { fontSize: "1.25rem", padding: "12px 16px" },
  };

  const sharedStyles = {
    width: "100%",
    boxSizing: "border-box",
    border: "1.5px solid",
    borderColor: error ? "#e00" : "#ccc",
    borderRadius: "5px",
    outlineOffset: "2px",
    transition: "border-color 0.3s ease",
    fontSize: sizeStyles[size].fontSize,
    padding: sizeStyles[size].padding,
    resize: "vertical",
  };

  const handleChange = (e) => {
    const val = e.target.value;
    if (numericOnly) {
      if (/^\d*$/.test(val)) onChange(e);
    } else {
      onChange(e);
    }
  };

  const isPassword = type === "password";

  return (
    <div
      className={`textfield-container ${className}`}
      style={{ marginBottom: "1rem", width: "100%", maxWidth: "400px" }}
    >
      {label && (
        <label
          htmlFor={name}
          style={{
            fontWeight: "600",
            fontSize: "1rem",
            color: "#333",
            marginBottom: "0.25rem",
            display: "block",
          }}
        >
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}

      <div style={{ position: "relative" }}>
        <input
          id={name}
          name={name}
          type={isPassword ? (showPassword ? "text" : "password") : type}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          autoComplete="off"
          inputMode={numericOnly ? "numeric" : undefined}
          style={{
            ...sharedStyles,
            paddingRight: isPassword ? "40px" : sizeStyles[size].padding,
          }}
        />

        {/* 👁 Eye Icon */}
        {isPassword && (
          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              fontSize: "1.1rem",
              color: "#666",
              userSelect: "none",
            }}
          >
             {showPassword ? <EyeOffIcon /> : <EyeIcon />}
          </span>
        )}
      </div>

      {error && (
        <div style={{ color: "#e00", fontSize: "0.875rem", marginTop: "0.25rem" }}>
          {error}
        </div>
      )}
    </div>
  );
};
const EyeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="black"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);


const EyeOffIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="black"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.94 17.94C16.23 19.27 14.19 20 12 20 5 20 1 12 1 12a21.8 21.8 0 0 1 5.06-6.94" />
    <path d="M9.9 4.24A9.77 9.77 0 0 1 12 4c7 0 11 8 11 8a21.8 21.8 0 0 1-2.17 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);


export default CustomTextField;
